import React from "react";
import { useTranslation } from "react-i18next";
import { Calculator } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "../../../ui/card";
import { Input } from "../../../ui/input";
import { Label } from "../../../ui/label";

const TunisiaOvertimeCard = ({ formData, handleInputChange }) => {
  const { t } = useTranslation();
  return (
  <Card>
    <CardHeader>
      <CardTitle className="flex items-center gap-2">
        <Calculator className="h-5 w-5" />
        {t("payrollTN.otTitle")}
      </CardTitle>
    </CardHeader>
    <CardContent className="space-y-4">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <Label htmlFor="overtime_normal">{t("payrollTN.otNormal")}</Label>
          <Input
            id="overtime_normal"
            type="number"
            step="0.01"
            min="1"
            max="3"
            value={formData.overtime_multiplier_default}
            onChange={(e) => handleInputChange("overtime_multiplier_default", parseFloat(e.target.value))}
          />
          <p className="text-xs text-muted-foreground mt-1">
            {t("payrollTN.otNormalHint")}
          </p>
        </div>

        <div>
          <Label htmlFor="overtime_night">{t("payrollTN.otNight")}</Label>
          <Input
            id="overtime_night"
            type="number"
            step="0.01"
            min="1"
            max="3"
            value={formData.night_overtime_multiplier}
            onChange={(e) => handleInputChange("night_overtime_multiplier", parseFloat(e.target.value))}
          />
          <p className="text-xs text-muted-foreground mt-1">
            {t("payrollTN.otNightHint")}
          </p>
        </div>

        <div>
          <Label htmlFor="overtime_weekend">{t("payrollTN.otWeekend")}</Label>
          <Input
            id="overtime_weekend"
            type="number"
            step="0.01"
            min="1"
            max="3"
            value={formData.weekend_overtime_multiplier}
            onChange={(e) => handleInputChange("weekend_overtime_multiplier", parseFloat(e.target.value))}
          />
          <p className="text-xs text-muted-foreground mt-1">
            {t("payrollTN.otWeekendHint")}
          </p>
        </div>

        <div>
          <Label htmlFor="overtime_holiday">{t("payrollTN.otHoliday")}</Label>
          <Input
            id="overtime_holiday"
            type="number"
            step="0.01"
            min="1"
            max="3"
            value={formData.holiday_overtime_multiplier}
            onChange={(e) => handleInputChange("holiday_overtime_multiplier", parseFloat(e.target.value))}
          />
          <p className="text-xs text-muted-foreground mt-1">
            {t("payrollTN.otHolidayHint")}
          </p>
        </div>
      </div>
    </CardContent>
  </Card>
  );
};

export default TunisiaOvertimeCard;
